import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { helper } from 'src/environments/helper';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private token!: string;
  private httpOptions: any;
  helper = helper;

  private basePath = environment.interop.basePath;
  private notificationsUrl =
    this.basePath +
    environment.interop.urbanism.notifications.authNotifications;

  private notificationSource = new Subject<{
    id: string;
    name: string;
  }>();
  currentNotification = this.notificationSource.asObservable();

  constructor(private http: HttpClient) {}

  async warningSwal(title: any, text: any, icon: any) {
    return await Swal.fire({
      icon: icon,
      title: title,
      text: text,
      showCancelButton: false,
      showConfirmButton: true,
      confirmButtonText: helper.dialogConfig.buttonLabels.close,
    });
  }

  changeNotification(notification: { id: string; name: string }) {
    this.notificationSource.next(notification);
  }

  getNotifications() {
    return this.http
      .get(this.notificationsUrl, this.httpOptions)
      .pipe(map((response: any) => response.data));
  }

  setToken(token: string) {
    this.token = token;
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${this.token}`,
      }),
    };
  }
}
